module.exports = __webpack_public_path__ + "static/media/main-desktop-browser-logos.81018b59.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/main-desktop-browser-logos.png
// module id = 1143
// module chunks = 0